/**
 * Alaska: App.js (PWA)
 * Data: Upload
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.data("Upload", () => ({
        visible: false,
        title: "",
        type: "handbook",
        file: null,

        toggle() {
            this.visible = !this.visible;
            if (!this.visible) {
                this.title = "";
                this.type = "handbook";
                this.file = null;
            }
        },

        close(){
            this.visible = false;
            this.title = "";
            this.type = "handbook";
            this.file = null;
        },

        async upload() {

            if (!this.file) {
                Alpine.store("overlay").render("error", "No file selected.");
                return;
            }

            Loading.show();

            const form = new FormData();
            form.append("action", "upload");
            form.append("controller", "documents");
            form.append("title", this.title);
            form.append("type", this.type);
            form.append("file", this.file);

            try {
                const res = await fetch("/", {
                    method: "POST",
                    body: form
                });

                const json = await res.json();

                Alpine.store("overlay").render(json.type, json.message);

                Loading.hide();
                this.close();

            } catch (err) {
                Alpine.store("overlay").render("error", "Upload failed.");
                console.error(err);

                Loading.hide();
                this.close();
            }

        }
    }));
});